"use client";

import Link from "next/link";
import { useParams } from "next/navigation";
import { isLocale, messagesFor } from "@/lib/i18n/locales";

export default function NotFound() {
  const params = useParams<{ locale?: string }>();
  const locale = params.locale && isLocale(params.locale) ? params.locale : "en";
  const messages = messagesFor(locale);
  return (
    <main id="main-content" className="error-page">
      <h1>{messages.notFoundTitle}</h1>
      <Link className="button primary" href={`/${locale}/workspace`}>{messages.notFoundAction}</Link>
    </main>
  );
}
